export const scrollTopPage = (behavior) => {
  const root = document.getElementById('customer-app')
  root.scrollIntoView({ behavior })
}
